export const BOOK_DATE_FORMAT:string = "yyyy年M月d日"
